export default "skymp5-front/41d969ed307cbba44d298539259d7961.png";